import React from 'react';
import PropTypes from 'prop-types';
import { Box, RadioButtonGroup } from 'grommet';

const RadioToggleButton = ({
  inactiveBg,
  activeBg,
  toggleBg,
  nameKey,
  updateParent = () => null,
  initialValue = null,
  isDisabled = false,
  customPad = null,
  ...rest
}) => {
  const [selected, setSelected] = React.useState(initialValue ?? false);

  // Toggle between true/false for larger clickable area
  const handleToggle = () => {
    if (isDisabled) return;
    const newValue = !selected;
    setSelected(newValue);
    updateParent(newValue);
  };

  const handleSelection = (value) => {
    let useValue = value;

    if (value === 'false') useValue = false;
    else if (value === 'true') useValue = true;

    setSelected(useValue);
    updateParent(useValue);
  };

  return (
    <Box
      background={selected ? activeBg : inactiveBg}
      round="50px"
      align="center"
      pad={customPad || '0.3rem'}
      style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset' }}
      onClick={handleToggle}
      {...rest}
    >
      <RadioButtonGroup
        name={nameKey}
        direction="row"
        gap="0.5rem"
        options={[
          { value: false, label: 'False' },
          { value: true, label: 'True' },
        ]}
        value={selected}
        onChange={(event) => handleSelection(event.target.value)}
        toggleBg={toggleBg}
        disabled={isDisabled}
      >
        {(option) => {
          let background = 'rgba(0,0,0,0)';

          if (selected.toString() === option.value.toString()) background = toggleBg;

          return (
            <Box background={background} round="50%" height="1.35rem" width="1.35rem" />
          );
        }}
      </RadioButtonGroup>
    </Box>
  );
};

RadioToggleButton.propTypes = {
  inactiveBg: PropTypes.string.isRequired,
  activeBg: PropTypes.string.isRequired,
  toggleBg: PropTypes.string.isRequired,
  nameKey: PropTypes.string.isRequired,
  updateParent: PropTypes.func,
  initialValue: PropTypes.bool,
  isDisabled: PropTypes.bool,
  customPad: PropTypes.string,
};

export default RadioToggleButton;
